import { render, staticRenderFns } from "./ProviderLegal.vue?vue&type=template&id=d30c78f6&"
import script from "./ProviderLegal.vue?vue&type=script&lang=js&"
export * from "./ProviderLegal.vue?vue&type=script&lang=js&"
import style0 from "./ProviderLegal.vue?vue&type=style&index=0&id=d30c78f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports